function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.32 2.04981L13.32 0.0498106H13.25C13.2035 0.0451322 13.1566 0.0451322 13.11 0.0498106H12.88H12.75H12.68L7 1.99981L1.32 0.0498106C1.16962 0.000222135 1.00961 -0.0129441 0.853139 0.0113954C0.696671 0.0357349 0.548219 0.0968843 0.420003 0.189811C0.290762 0.281827 0.185268 0.403274 0.112238 0.544118C0.039208 0.684962 0.000736954 0.84116 3.33354e-06 0.999811V14.9998C-0.000537828 15.2095 0.0648223 15.414 0.186845 15.5844C0.308868 15.7549 0.481382 15.8827 0.680003 15.9498L6.68 17.9498C6.88145 18.0155 7.09856 18.0155 7.3 17.9498L13 16.0498L18.68 17.9998C18.7862 18.0142 18.8938 18.0142 19 17.9998C19.2091 18.0028 19.4132 17.9359 19.58 17.8098C19.7092 17.7178 19.8147 17.5963 19.8878 17.4555C19.9608 17.3147 19.9993 17.1585 20 16.9998V2.99981C20.0005 2.79017 19.9352 2.58565 19.8132 2.41518C19.6911 2.24471 19.5186 2.1169 19.32 2.04981ZM6 15.6098L2 14.2798V2.38981L6 3.71981V15.6098ZM12 14.2798L8 15.6098V3.71981L12 2.38981V14.2798ZM18 15.6098L14 14.2798V2.38981L18 3.71981V15.6098Z",
    fill: props.fill
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.c1aad3ee6cc3ae0e35b50791f889e256.svg";
export { ForwardRef as ReactComponent };